var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.164 0 0 7.164 0 16C0 19.0016 0.843122 21.8001 2.28125 24.2005L0.143229 32L8.10938 29.9089C10.4391 31.2334 13.1287 32 16 32C24.836 32 32 24.836 32 16C32 7.164 24.836 0 16 0ZM10.5234 8.53646C10.7834 8.53646 11.0506 8.53488 11.2813 8.54688C11.5666 8.55354 11.8771 8.57444 12.1745 9.23177C12.5278 10.0131 13.2972 11.9732 13.3958 12.1719C13.4945 12.3705 13.5644 12.6046 13.4271 12.8646C13.2964 13.1313 13.2285 13.2926 13.0365 13.5286C12.8378 13.758 12.6201 14.0428 12.4401 14.2161C12.2414 14.4148 12.0363 14.6326 12.2656 15.0286C12.495 15.4246 13.2914 16.7228 14.4687 17.7708C15.9821 19.1228 17.2589 19.5383 17.6563 19.737C18.0536 19.9356 18.2837 19.9047 18.513 19.638C18.749 19.378 19.5042 18.4859 19.7708 18.0885C20.0308 17.6912 20.2963 17.76 20.6563 17.8906C21.0216 18.0213 22.9699 18.981 23.3672 19.1797C23.7645 19.3784 24.025 19.4767 24.125 19.638C24.2277 19.8047 24.2278 20.5981 23.8984 21.5234C23.5691 22.4474 21.9519 23.341 21.2266 23.4036C20.4946 23.4716 19.8114 23.7327 16.4687 22.4167C12.4368 20.8287 9.89398 16.699 9.69531 16.4323C9.49665 16.1723 8.08073 14.2852 8.08073 12.3385C8.08073 10.3852 9.10488 9.42858 9.46354 9.03125C9.82888 8.63392 10.2568 8.53646 10.5234 8.53646Z",
    fill: "#4F0077"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.5d329bda427da06452137389d1b9c462.svg";
export { ForwardRef as ReactComponent };